import React from 'react';
import PropTypes from 'prop-types';

import Modal from 'shared/components/modal';
import NewTabTooltip from 'shared/components/new-tab-tooltip';
import InstitutionChooser from 'shared/institution-chooser/components/institution-chooser';

const propTypes = {
  countries: PropTypes.array,
  hideModal: PropTypes.func,
  onSubmitModal: PropTypes.func,
  onSwitchCountry: PropTypes.func,
  fieldName: PropTypes.string,
};

const FindInternationalHighSchoolModal = ({
  hideModal,
  countries,
  onSwitchCountry,
  fieldName,
  onSubmitModal = () => {},
}) => {
  const onClick = () => {
    onSubmitModal();
    hideModal();
  };

  return (
    <>
      <Modal.TextHeader
        onClose={hideModal}
        textAlign="center"
        subtitle="Tell us more about where your school is located"
      >
        Check for Your High School
      </Modal.TextHeader>
      <Modal.Body>
        <InstitutionChooser
          introContent={<legend className="shared-required-legend"></legend>}
          countries={countries}
          onSwitchCountry={onSwitchCountry}
          fieldName={fieldName}
        />

        <span className="cannot-find-school">
          Still can&apos;t find your high school? &nbsp;
          <NewTabTooltip>
            <a
              href="https://help.raise.me/hc/en-us/articles/360003494493-I-can-t-find-my-high-school-Non-US"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Raise Me Support: I can't find my high school (Non-US)"
            >
              Learn More
            </a>
          </NewTabTooltip>
        </span>
      </Modal.Body>
      <Modal.Footer
        primaryButton={{
          text: 'Continue',
          onClick: onClick,
          width: '100%',
        }}
      />
    </>
  );
};

FindInternationalHighSchoolModal.propTypes = propTypes;

export default FindInternationalHighSchoolModal;
